var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ReportingSettings", {
    attrs: {
      "available-filters": _vm.availableFilters,
      "default-title": _vm.$t("DEFAULT_INSIGHTS_TITLE"),
      "active-report": _vm.activeInsight,
      "report-type": _vm.reportType,
      "time-range": _vm.activeInsightTimeRange,
      "time-zone-id": _vm.activeInsightTimeZoneId,
      "translated-time-zone-id": _vm.activeInsightTranslatedTimeZoneId,
      "last-updated": _vm.activeInsightLastUpdated,
      "filter-criteria": _vm.activeInsightFilterCriteria,
      "quick-filters": _vm.insightsQuickFilters,
      "form-name-for-user-settings": "reportingFilterUserSettings"
    },
    on: {
      dateRangeChange: function($event) {
        return _vm.$emit("dateRangeChange")
      },
      saveReport: _vm.saveInsight,
      deleteReport: _vm.deleteInsight,
      duplicateReport: _vm.duplicateInsight,
      refreshData: _vm.refreshInsightGridData,
      onStartTour: function($event) {
        return _vm.$emit("onStartTour")
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }